import styled from '@emotion/styled'

export interface ContainerProps {
  maxWidth?: number | string
  padX?: string
  padY?: string
}

// Container — centered max-width column with symmetric horizontal padding.
// Used to wrap any section of page content so consumers don't reinvent
// `maxWidth + margin: 0 auto + padding`.
export const Container = styled.div<ContainerProps>`
  width: 100%;
  margin: 0 auto;
  max-width: ${({ maxWidth = 1320 }) =>
    typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth};
  padding-left: ${({ padX = 'var(--s-9)' }) => padX};
  padding-right: ${({ padX = 'var(--s-9)' }) => padX};
  padding-top: ${({ padY = '0' }) => padY};
  padding-bottom: ${({ padY = '0' }) => padY};
  box-sizing: border-box;
`

// PageSection is Container plus vertical rhythm — the most common
// "padded section of a page" pattern in our area apps.
export const PageSection = styled(Container)`
  padding-top: var(--s-10);
  padding-bottom: var(--s-10);
`
